import { Component, inject } from '@angular/core';
import { ChemicalService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ChemicalCreateDto,
  ChemicalDto,
  ChemicalExcelDownloadDto,
  ChemicalUpdateDto,
} from '../proxy/general/dtos/chemical';
import { CHEMICAL_CONFIG, CHEMICAL_FIELDS } from './chemical.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-chemical',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ChemicalService, ConfirmationService],
  templateUrl: './chemical.html',
  styleUrl: './chemical.scss',
})
export class Chemical extends BaseHierarchicalCrudComponent<
  ChemicalDto,
  ChemicalCreateDto,
  ChemicalUpdateDto,
  ChemicalExcelDownloadDto
> {
  service = inject(ChemicalService);
  config = CHEMICAL_CONFIG;
  fields = CHEMICAL_FIELDS;

  protected prepareUpdateDto(data: any, selected: ChemicalDto): ChemicalUpdateDto {
    return {
      standardAcceptedDeviation: data.standardAcceptedDeviation,
      chemicalTypeId: data.chemicalTypeId,
      consumableId: data.consumableId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Chemical';
  }
}
